export type BadgeType = 'new' | 'expiring' | null;

export type PrimaryTab = 'bonus' | 'coupon';

export const ItemStatus = {
  AVAILABLE: 1,
  USED: 2,
  EXPIRED: 3,
} as const;
export type ItemStatus = typeof ItemStatus[keyof typeof ItemStatus];

export interface CouponItem {
  /**
 * 点击动作类型，例如 jump
 */
  action_type: string;
  /**
   * 点击跳转地址或业务路由
   */
  action_url: string;
  /**
   * 服务端返回的展示排序值，前端直接使用
   */
  display_order: number;
  /**
   * 生效时间，Unix时间戳，0表示立即生效
   */
  effective_at: number;
  /**
   * 过期时间，Unix时间戳，0表示不过期
   */
  expire_at: number;
  /**
   * 外部系统中的道具实体ID
   */
  external_item_id: string;
  /**
   * 道具图标地址
   */
  icon: string;
  /**
   * 是否临期，通常指1小时内过期
   */
  is_near_expire: boolean;
  /**
   * 当前道具是否带未读红点
   */
  is_red_dot: boolean;
  /**
   * 背包道具实例ID
   */
  item_id: number;
  /**
   * 道具类型，例如 rummy_ticket、fantasy_coupon
   */
  item_type: string;
  /**
   * 道具主标题
   */
  name: string;
  /**
   * 道具来源系统，例如 rummy、fantasy
   */
  source: string;
  /**
   * 当前展示格内的叠加数量
   */
  stack_count: number;
  /**
   * 道具状态：1=正常 2=已使用 3=已失效
   */
  status: number;
  /**
   * 道具副标题
   */
  sub_name: string;
  /**
   * 当前道具所属一级Tab编码
   */
  tab_code: string;
  /**
   * 道具模板ID
   */
  template_id: number;
  /**
   * 比赛id
   */
  match_id?: string;
  /**
   * 系列赛id
   */
  tour_id?: string;
  /**
   * 道具目标
   */
  target?: {
    /**
     * 目标字段，例如 match_id、tour_id
     */
    target_field: string;
    /**
     * 目标ID
     */
    target_id: string;
  }[];
  /**
   * 最近获取或刷新时间，Unix时间戳
   */
  grant_at: number;
  /**
   * 道具名称 埋点上报
   */
  prop_name: string;
}
